import styled from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import ContentItemCarousel from '../../ui-components/ContentItemCarousel/ContentItemCarousel';
import Showcase from '../../ui-components/Showcase/Showcase';

export const RecommendedCarousel = styled(ContentItemCarousel)`
    display: none;

    @media ${device.GteXLarge} {
        display: block;
    }
`;

export const RecommendedShowcase = styled(Showcase)`
    display: block;

    @media ${device.GteXLarge} {
        display: none;
    }
`;
